"use strict";
const iniciar = () => {
  const form = document.querySelector("[data-focasos-reglamento]");
  if (!form) {
    return;
  }
  const fin = document.querySelector("[data-focasos-reglamento-fin]") || form;
  const casilla = form.querySelector("[data-focasos-reglamento-casilla]");
  const boton = form.querySelector("[data-focasos-reglamento-boton]");
  const estado = form.querySelector("[data-focasos-reglamento-estado]");
  let observador = null;
  const sincronizarBoton = () => {
    boton.disabled = casilla.disabled || !casilla.checked;
  };
  const llegadoAlFinal = () => {
    casilla.disabled = false;
    estado.textContent = "Has llegado al final del texto. Marca la casilla para aceptarlo.";
    sincronizarBoton();
    if (observador) {
      observador.disconnect();
    }
  };
  casilla.addEventListener("change", sincronizarBoton);
  casilla.disabled = true;
  casilla.checked = false;
  sincronizarBoton();
  estado.textContent = "Sigue bajando hasta el final del texto: la casilla se activa al llegar.";
  if (!("IntersectionObserver" in window)) {
    llegadoAlFinal();
    return;
  }
  observador = new IntersectionObserver((entradas) => {
    if (entradas.some((entrada) => entrada.isIntersecting)) {
      llegadoAlFinal();
    }
  }, { rootMargin: "0px 0px -20px 0px" });
  observador.observe(fin);
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", iniciar);
} else {
  iniciar();
}
